import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleTuitionFee extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length === 1 && this.indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE)
		);
	}

	protected getPageTitle(): string {
		return `Affordable ${this.titlePortalType} from around the world`;
	}

	protected getMetaTitle(): string {
		return `${this.totalSearchResults} affordable ${this.titlePortalType} from around the world | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`and most affordable ${this.titlePortalType} worldwide`);
	}
}
